module.exports = __webpack_public_path__ + "static/media/no6.92ae9496.png";